import React, { FC, ReactNode, useEffect, useRef } from "react";
import { css } from "@emotion/css";

import useTheme from "evcharging/hooks/useTheme";
import { Theme } from "evcharging/app/themes";

interface RatesModalProps {
  width?: number;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

const useOutsideAlerter = (ref, onOutside: () => void ) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutside();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const RatesModal: FC<RatesModalProps> = (props) => {
  const { width, open, onClose, children } = props;
  const theme = useTheme();
  const styles = createStyles(theme, width);
  const ref = useRef<HTMLDivElement>(null);

  useOutsideAlerter(ref, onClose);

  if (!open) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.content} ref={ref}>
        <button className={styles.close} onClick={onClose}>
          ✕
        </button>
        <div className={styles.cart}>
          <div className={styles.inner}>{children}</div>
        </div>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme, width) => ({
  root: css`
    position: fixed;
    z-index: 100000;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 0;
    max-height: 100vh;
    overflow: hidden;
  `,
  content: css`
    position: relative;
    overflow: auto;
    z-index: 1001;
    height: 100%;
    opacity: 1;
  `,
  cart: css`
    width: ${width ||600}px;
    max-width: ${width ||600}px;
    background: inherit;
    ${theme.breakpoints.mobile.down} {
      width: 100vw;
    }
  `,
  inner: css`
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    padding: 24px 32px;
    ${theme.breakpoints.mobile.down} {
      padding: 12px;
    }
  `,
  close: css`
    position: absolute;
    text-align: center;
    cursor: pointer;
    padding: 0;
    font-size: 1.575rem;
    right: 10px;
    top: 10px;
    z-index: 1002;
    line-height: 1;
    outline: none;
    background: none;
    border: none;
    color: #1a1a1a;
    transition: all ease-in 0.1s;

    :hover {
      font-size: 1.875rem;
    }
  `,
});

export default RatesModal;
